import React, { createContext, useReducer } from "react";
import Reducer from './Reducer'
import AsyncStorage from '@react-native-async-storage/async-storage';
import { MakeReference } from '../../constants/Utils';
import useOrderMeta from '../../hooks/useOrderMeta';
import useMounted from "../../hooks/useMounted";
import http from "../../utils/http";

const initialState = {
    order_group: null,
    order_group_items: [],
    error: null,
};

const CartStore = ({ children }) => {
    const isMounted = useMounted()
    const [state, dispatch] = useReducer(Reducer, initialState);
    const order_meta = useOrderMeta()

    const fetch = async () => {
        const getStore = async () => {
            const buyerData = await AsyncStorage.getItem('buyerData')
            const orderGroup = await AsyncStorage.getItem('orderGroup')
            const orderGroupItems = await AsyncStorage.getItem('orderGroupItems')
            const token = await AsyncStorage.getItem('userToken')
            const buyer = await AsyncStorage.getItem('buyerId')

            return await {
                token,
                buyer,
                buyerData: JSON.parse(buyerData),
                orderGroup: JSON.parse(orderGroup),
                orderGroupItems: JSON.parse(orderGroupItems),
            }
        }

        const do_dispatch = (obj) => {
            isMounted.current && dispatch(obj)
        }

        return new Promise((resolve, reject) => {

            getStore()
                .then(store => {

                    do_dispatch({ type: 'SET_ORDER_GROUP', payload: store.orderGroup });
                    do_dispatch({ type: 'SET_ORDER_GROUP_ITEMS', payload: Array.from(store.orderGroupItems || []) });
                    // read user's cart, if any exists
                    let form = new FormData()
                    form.append('ref', MakeReference(8))
                    form.append('tag', 'draft')
                    form.append('meta', order_meta)
                    form.append('amount', '0')
                    form.append('buyer_id', store.buyer)
                    let req_order_group = http.post('order_group/create', form, store.token)

                    Promise.all([req_order_group])
                        .then(([order_res]) => {

                            if (order_res.code === 200 && order_res.message === true) {
                                let refresh_form = new FormData()
                                refresh_form.append('_id', order_res.data)
                                http.post('order_group/refresh', refresh_form, store.token)
                                    .then(refresh_res => {
                                        form = new FormData()
                                        form.append('_id', order_res.data)
                                        http.post('order_group/read', form, store.token)
                                            .then(res => {
                                                if (res.code === 200) {
                                                    AsyncStorage.setItem('orderGroup', JSON.stringify(res.data[0]))
                                                    do_dispatch({ type: 'SET_ORDER_GROUP', payload: res.data[0] })

                                                    // read order_group_items
                                                    form = new FormData()
                                                    form.append('order_group_id', order_res.data)
                                                    http.post('order_group_item/read_by_order_group', form, store.token)
                                                        .then(res => {
                                                            if (res.code === 200) {
                                                                AsyncStorage.setItem('orderGroupItems', JSON.stringify(res.data))
                                                                do_dispatch({ type: 'SET_ORDER_GROUP_ITEMS', payload: res.data })
                                                                resolve(res.data)
                                                            } else {
                                                                console.log(res.message)
                                                                reject(res)
                                                            }
                                                        })
                                                        .catch(err => {
                                                            console.log(err)
                                                            reject(err)
                                                        })
                                                } else {
                                                    console.log(res.message)
                                                    reject(res)
                                                }
                                            })
                                            .catch(err => {
                                                console.log(err)
                                                reject(err)
                                            })
                                    })
                                    .catch(err => {
                                        console.log(err)
                                        reject(err)
                                    })

                            } else {
                                console.log(order_res.message)
                                reject(order_res)
                            }
                        })
                        .catch(err => {
                            console.log(err)
                            reject(err)
                        })
                })
                .catch(err => {
                    console.log(err)
                    reject(err)
                })
        })
    }

    return (
        <CartContext.Provider value={[state, dispatch, fetch]}>
            {children}
        </CartContext.Provider>
    )
};

export const CartContext = createContext(initialState);
export default CartStore;